import React, { useState } from 'react';

function FirmSwitcher() {
    const [isOpen, setIsOpen] = useState(false);

    // Get firms from properly injected global variable
    const firms = window.CURRENT_USER?.firms || [];

    // If no firms, don't render switcher (or render empty state if meaningful, but mostly handled by creation flow)
    if (firms.length === 0) return null;

    const currentFirmId = localStorage.getItem('current_firm_id');
    // Find current firm object or default to first
    const currentFirm = firms.find(f => f.id.toString() === currentFirmId) || firms[0];

    // Ensure we have a valid selection in storage if not already
    if (!currentFirmId && firms.length > 0) {
        localStorage.setItem('current_firm_id', firms[0].id);
    }

    const handleSwitch = (firmId) => {
        localStorage.setItem('current_firm_id', firmId);
        setIsOpen(false);
        // Reload to refresh all data with new firm context
        window.location.reload();
    };

    return (
        <div className="relative">
            <button
                onClick={(e) => {
                    e.stopPropagation();
                    setIsOpen(!isOpen);
                }}
                className="flex items-center gap-2 px-3 py-2 rounded-lg hover:bg-slate-50 transition-colors border border-slate-200"
            >
                <div className="w-6 h-6 bg-slate-100 rounded flex items-center justify-center text-xs font-bold text-slate-600">
                    {currentFirm.name.substring(0, 2).toUpperCase()}
                </div>
                <span className="text-sm font-medium text-slate-700 max-w-[150px] truncate">
                    {currentFirm.name}
                </span>
                <svg className={`w-4 h-4 text-slate-400 transition-transform ${isOpen ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                </svg>
            </button>

            {isOpen && (
                <>
                    <div
                        className="fixed inset-0 z-30 bg-transparent cursor-default"
                        onClick={() => setIsOpen(false)}
                    />
                    <div className="absolute left-0 mt-2 w-64 bg-white rounded-xl shadow-lg border border-slate-200 py-2 z-50 animate-in fade-in zoom-in-95 duration-100">
                        <div className="px-4 py-2 border-b border-slate-50">
                            <h3 className="text-xs font-semibold text-slate-500 uppercase tracking-wider">
                                Switch Business
                            </h3>
                        </div>
                        <div className="max-h-64 overflow-y-auto">
                            {firms.map(firm => (
                                <button
                                    key={firm.id}
                                    onClick={() => handleSwitch(firm.id)}
                                    className={`w-full flex items-center gap-3 px-4 py-2 text-sm transition-colors ${(currentFirmId === firm.id.toString() || (!currentFirmId && firm.id === firms[0].id))
                                            ? 'bg-indigo-50 text-indigo-700'
                                            : 'text-slate-700 hover:bg-slate-50'
                                        }`}
                                >
                                    <div className={`w-8 h-8 rounded flex items-center justify-center text-xs font-bold ${(currentFirmId === firm.id.toString() || (!currentFirmId && firm.id === firms[0].id))
                                            ? 'bg-indigo-100 text-indigo-600'
                                            : 'bg-slate-100 text-slate-500'
                                        }`}>
                                        {firm.name.substring(0, 2).toUpperCase()}
                                    </div>
                                    <div className="text-left">
                                        <p className="font-medium truncate max-w-[160px]">{firm.name}</p>
                                    </div>
                                    {(currentFirmId === firm.id.toString() || (!currentFirmId && firm.id === firms[0].id)) && (
                                        <svg className="w-4 h-4 ml-auto text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                                        </svg>
                                    )}
                                </button>
                            ))}
                        </div>
                        <div className="border-t border-slate-100 mt-2 pt-2 px-2">
                            <a
                                href="/firms/new"
                                className="flex items-center gap-2 w-full px-2 py-2 text-sm font-medium text-slate-600 hover:text-indigo-600 hover:bg-slate-50 rounded-lg transition-colors"
                            >
                                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4" />
                                </svg>
                                Add New Business
                            </a>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
}

export default FirmSwitcher;
